import React, { useEffect, useState } from "react";
import { Row, Col, Button } from 'react-bootstrap';
import styles from "./PartialProductDetailsPrice.module.css"
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { IColor } from '../../utilities/settings'
import ContactUsPage from "../../pages/contactUsPage/ContactUsPage";

export interface IProductColors {
    itemColorId: number,
    colorId: number,
    unitPrice: number,
    colorCode: string,
    colorName: string
}
export interface IProductDetailsPrice {
    itemId: number,
    itemCode: string,
    itemDescription: string[],
    assetURL: string,
    modelCode: string,
    unitPrice: number,
    newPrice: number,
    displayOrder: number,
    brand: any,
    category: any,
    isOfferAvailable: boolean,
    itemName: string,
    pdfurl: string,
}
interface IDealers {
    itemSellerMappingID: number,
    webSiteLink: string,
    logoLink: string,
    sellerLink: string,
    displayOrder: number,
}
interface PropsType {
    productCard: IProductDetailsPrice,
    dealers: IDealers[],
    colorCode: IColor,
    itemColor: IProductColors[],
}


export default function PartialProductDetailsPrice(props: any) {
    const responsive = useSelector((state: RootState) => state.responsive);
    const [isWeb, setIsWeb] = useState<boolean>(true);
    const [selectedColor, setSelectedColor] = useState<IProductColors>();
    const [hoverColorName, setHoverColorName] = useState("");
    const [contactNo, setContactNo] = useState("");

    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
        if (props.productCard.category.subDepartment.contactNumber != "") {
            setContactNo(props.productCard.category.subDepartment.contactNumber)
        }
        else {
            setContactNo(props.productCard.category.department.contactNumber)
        }
    }, [])

    function price(val: number) {
        var value = (Math.round(val * 100) / 100).toFixed(2);
        return "Rs. " + String(value).replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1,');
    }
    function clickLink(dealer: IDealers) {
        debugger
        if (dealer.sellerLink !== "") {
            window.open(dealer.sellerLink, '_blank');
        }
        else {
            window.open(dealer.webSiteLink, '_blank');
        }
    }

    const downloadPDF = (link: string) => {
        window.open(link, '_blank');
    };

    function selectColor(itemColorId: number) {
        var item = props.itemColor.filter((a: any) => a.itemColorId == itemColorId)[0];
        setSelectedColor(item);
        setHoverColorName(item.colorName)
        props.onChange(itemColorId);
    }


    return (
        <React.Fragment>
            <div className={`${styles.mainContainer}`}>
                <Row className={`${styles.row}`}>
                    <div className={`${styles.detailContainer}`}>
                        <div className={`${styles.selectedBrandHeading}`}>
                            <span>{props.productCard.brand.brandName}</span>
                        </div>
                        <div className={`${styles.mainText}`} style={{ color: props.colorCode.secondaryColor }}>
                            <p className={`${styles.lineClamp}`}>{props.productCard.itemName}</p>
                        </div>
                        <Row style={{ marginBottom: "10px", marginTop: "15px" }}>
                            {props.productCard.isOfferAvailable == false ?
                                <div className={`${styles.price}`}>
                                    {!selectedColor ?
                                        <p>{props.productCard.unitPrice != 0 ? price(props.productCard.unitPrice) : null}</p>
                                        : <p>{selectedColor.unitPrice != 0 ? price(selectedColor.unitPrice) : null}</p>
                                    }
                                </div>
                                :
                                <div style={{ display: "flex" }}>
                                    <div className={`${styles.priceCut}`}>
                                        <del>{price(props.productCard.unitPrice)}</del>
                                    </div>
                                    <div className={`${styles.price}`} style={{ marginLeft: "15px" }}>
                                        <span>{price(props.productCard.newPrice)}</span>
                                    </div>
                                </div>
                            }
                        </Row>
                        <div style={isWeb ? { maxHeight: "300px", overflowY: "auto" } : {}} >
                            {props.productCard.itemDescription.map((desc: any) => {
                                return (<p style={{ lineHeight: "23px" }}>{desc}</p>)
                            })}
                        </div>
                    </div>
                </Row>

                <div style={{ textAlign: "left", height: "17px", paddingLeft: "10px", fontFamily: "Montserrat-bold" }}>{hoverColorName}</div>
                <div className={`${styles.thumbnailContainer}`}>
                    {props.itemColor.map((item: IProductColors) => {
                        return (
                            <div key={item.itemColorId} onClick={() => selectColor(item.itemColorId)}
                                style={{ backgroundColor: item.colorCode, border: item.colorId == selectedColor?.colorId ? "2px solid" + props.colorCode.secondaryColor : "" }}
                                className={`${styles.colorThumbnail} ${item.colorId == selectedColor?.colorId ? styles.selectedColor : null}`}
                                onMouseEnter={() => setHoverColorName(item.colorName)} onMouseLeave={() => setHoverColorName(selectedColor?.colorName || "")}>
                            </div>
                        );
                    })
                    }
                </div>
                {props.dealers != undefined && props.dealers.length > 0 ?
                    <Row className={`${styles.brandsSection}`}
                        style={{ filter: props.productCard.isInStock ? "null" : "grayscale(100%)" }}>
                        {props.dealers.map((item: any, index: number) => {
                            return (
                                <Col key={index} style={{ padding: "0" }} lg="12" md="12" xs="12" className="d-flex">
                                    <div key={item.itemSellerMappingID} className={`${styles.brandSection}`}>
                                        <div className={`${styles.logo}`}>
                                            <img src={item.logoLink} alt={item.webSiteLink + `-img`} className="img-fluid" style={{ height: "100%" }} />
                                        </div>
                                        <div className={`${styles.checkout}`}>
                                            <Button onClick={() => clickLink(item)} disabled={!props.productCard.isInStock}
                                                className="jkoa-card-transparent-blue-btn">
                                                <div style={{ padding: "0", margin: "0" }}>Shop Now</div>
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                    : null
                }
                <Row style={{ display: props.productCard.isInStock ? "none" : "block" }}>
                    <div className={`${styles.outOfStock}`}>THIS ITEM IS OUT OF STOCK!
                    </div>
                </Row>
                <Row className={`${styles.btnContainer}`}>
                    <Col lg="3" md="6" xs="12" hidden>
                        <Button className="jkoa-blue-btn" style={{ width: "100%", marginBottom: "5px" }}>
                            <div style={{ padding: "0", margin: "0" }}>checkout</div>
                        </Button>
                    </Col>

                    {contactNo !== "" ?
                        <Col lg="3" md="6" xs="12" style={{ padding: "0 4px" }}>
                            <a href={"tel:" + +94 + contactNo}>
                                <Button className="jkoa-blue-btn" style={{ width: "100%", marginBottom: "5px", paddingLeft: "0", paddingRight: "0" }}>
                                    <i className="fas fa-phone-alt" style={{ marginRight: "3px" }}></i>
                                    (+94) {contactNo.replace(/^(.{2})(.*)$/, "$1 $2")}
                                </Button>
                            </a>
                        </Col>
                        : null}
                    <Col lg="3" md="6" xs="12" style={{ padding: "0 4px" }}>
                        <Button className="jkoa-blue-btn" style={{ width: "100%", marginBottom: "5px" }}
                            onClick={() => window.location.href = "/contact/" + props.productCard.itemCode + "/" + props.productCard.brand.brandName + " " + props.productCard.itemName}>
                            <div style={{ padding: "0", margin: "0" }}>Inquire Now</div>
                        </Button>
                    </Col>
                    {props.productCard.pdfurl !== null ?
                        <Col lg="3" md="6" xs="12" style={{ padding: "0 4px" }}>
                            <Button className="jkoa-blue-btn" style={{ width: "100%", marginBottom: "5px" }}
                                onClick={() => downloadPDF(props.productCard.pdfurl)}>
                                <div style={{ padding: "0", margin: "0" }}>Download</div>
                            </Button>
                        </Col>
                        :
                        <></>
                    }
                    <Col lg="3" md="6" xs="12" style={{ padding: "0 4px" }} hidden>
                        <Button className="jkoa-blue-btn" style={{ width: "100%", marginBottom: "5px" }}
                            onClick={() => window.location.href = "/findDealers"}>
                            <div style={{ padding: "0", margin: "0" }}>FIND DEALER</div>
                        </Button>
                    </Col>
                    <Col lg="3" md="6" xs="12" style={{ padding: "0 4px" }}>
                        <a style={{ textDecoration: "none" }} href={`/productCompare?ic=${props.productCard.itemCode}&${props.productCard.itemName.replace(/ /g, "_").toUpperCase()}`}>
                            <Button className="jkoa-blue-btn" style={{ width: "100%", marginBottom: "5px" }}>
                                <div style={{ padding: "0", margin: "0" }}>Compare</div>
                            </Button>
                        </a>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}